export default {"src":"/_next/static/media/pets.95f538c6.svg","height":116,"width":116,"blurWidth":0,"blurHeight":0};